var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"nav",staticClass:"header_tab"},[_c('ul',{staticClass:"tab_content"},_vm._l((_vm.tabList),function(item,index){return _c('li',{key:index,attrs:{"id":item.id,"clstag":`newscenter|keycount|headerTab-pc|click-${item.code}`},on:{"click":function($event){return _vm.up(item)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }